import React, { useState } from "react";
import { Button, Grid, Icon, Label, List, Select } from "semantic-ui-react";
import PropTypes from "prop-types";
import superagent from "superagent";
import { AUTH_API_URL } from "../../../constants";

import { SYSTEM_ROLES, ABLETON_ROLES } from '../../../../server/constants';
import useCanAdminRoles from "../../../hooks/useCanAdminRoles";
import useCanAdminSystemRoles from "../../../hooks/useCanAdminSystemRoles";

const isSystemRole = r => Object.values(SYSTEM_ROLES).includes(r) || Object.values(ABLETON_ROLES).includes(r);

const UserRoles = ({
  profile,
  availableRoles = [],
  refreshUser,
}) => {

  const canAdminRoles = useCanAdminRoles();
  const canAdminSystemRoles = useCanAdminSystemRoles();

  const [selectedRole, setSelectedRole] = useState(null);

  // Filter out roles that user already has
  const rolesForUser = availableRoles.filter((r) => !(profile.roles || []).includes(r.name));

  const handleModifyRoles = (roles) => {
    superagent
      .patch(`${AUTH_API_URL}/users/${profile._id}/roles`)
      .send({ roles })
      .withCredentials()
      .then(() => {
        refreshUser();
        setSelectedRole(null);
      })
      .catch((err) => {
        const errorMessage =
          (err.response && err.response.body && err.response.body.error) ||
          "There was a problem modifying roles. Please try again.";
        window.alert(errorMessage);
        refreshUser();
        setSelectedRole(null);
      });
  };

  const handleRemoveRole = (role) => {
    if (window.confirm(`Are you sure you want to remove the ${role} role?`)) {
      const remainingRoles = profile.roles.filter((r) => r !== role);
      handleModifyRoles(remainingRoles);
    }
  };

  const handleRoleSelectionChange = (e, data) => {
    e.preventDefault();
    setSelectedRole(data.value);
  };

  const handleAddRole = () => {
    const userRoles = profile.roles || [];

    if (!userRoles.includes(selectedRole)) {
      const roles = [...userRoles, selectedRole];
      handleModifyRoles(roles);
    }
  };

  return (
    <Grid columns={canAdminRoles ? 2 : 1}>
      <Grid.Column>
        <List>
          {profile.roles && profile.roles.length ? profile.roles.map((role) => (
            <List.Item key={role}>
              <div>
                <Label size="large">
                  <div style={{ display: "flex", columnGap: "16px", alignItems: "center" }}>
                    <div>
                      <div style={{ marginBottom: "4px" }}>
                        {role}
                      </div>
                      <small>
                        {(availableRoles.find((r) => r.name === role) || {}).description}
                      </small>
                    </div>
                    {
                      canAdminRoles && (canAdminSystemRoles || !isSystemRole(role)) ? (
                        <Icon
                          name="delete"
                          onClick={() => handleRemoveRole(role)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : null
                    }
                  </div>
                </Label>
              </div>
            </List.Item>
          )) : (
            <List.Item>
              No roles assigned.
            </List.Item>
          )}
        </List>
      </Grid.Column>

      {canAdminRoles ? (
        <Grid.Column>
          <h4>Add a role</h4>
          <Select
            fluid
            search
            selection
            placeholder="Select a role"
            onChange={handleRoleSelectionChange}
            value={selectedRole}
            options={
              rolesForUser
                .filter(role => canAdminSystemRoles || !isSystemRole(role.name))
                .map((role) => ({
                  key: role.name,
                  value: role.name,
                  text: role.name,
                  description: role.description,
                }))
            }
          />
          <Button
            positive
            disabled={!selectedRole}
            style={{ marginTop: "16px" }}
            onClick={handleAddRole}
          >
            Save
          </Button>
        </Grid.Column>
      ) : null}
    </Grid>
  );
};

UserRoles.propTypes = {
  profile: PropTypes.object.isRequired,
  availableRoles: PropTypes.array,
  refreshUser: PropTypes.func.isRequired,
}

export default UserRoles;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/roles.js